/**
 * 
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import TopNav from  '../PatientApp/TopNav';
import ErrorBar from "./../ErrorBar/ErrorBar";
import { Trans } from "react-i18next";
import Helper from '../../Documental/AppFeatureFlags/Helper';

import StateMachine from 'react-simple-state/dist';
import { set } from 'date-fns';
import i18n from '../../Documental/Localization/i18n';
const appState = new StateMachine();

const RepeatVisitLandingPage = ( props ) => {
  const navigate = useNavigate();
  
  const handleProceedClick = (   ) => {
    navigate( './../booking' );
    return false;
  } 
  
  return (
    <div className="app-page landing">
      <RepeatVisitLandingPageClass onProceedClick={handleProceedClick} />
    </div>
  );
}


class RepeatVisitLandingPageClass extends React.Component {

  constructor( props ) {
    super( props );

    this.state = {
      "forceRenderCnt" : 1,
      "finishedTryingToLoad" : false,
      "proccedClicked" : false,
      "permanentlyFailed" : false
    }

    this._isMounted = false;
    
    this.handleVideoCallClick = this.handleVideoCallClick.bind(this);
    this.handleBookAppointmentClick = this.handleBookAppointmentClick.bind(this);
    
    // this.eventServerCommunicationInRaw = this.eventServerCommunicationInRaw.bind( this );
    
    this.timerPollServiceRequestLoadedPoll = null;
    this.serviceRequestLoadedTimeoutCount = 0;

    this.timerPollServiceRequestSyncedPoll = null;
    this.serviceRequestSyncingTimeoutCount = 0;
  }


  componentDidMount() {
    this._isMounted = true;
    var that = this;
    
    //if( typeof window.appEventsEmitter !== 'undefined' ){
    //  window.appEventsEmitter.addListener( 'ServerCommunicationInRaw', this.eventServerCommunicationInRaw );
    //}

    appState.subscribe( 'app-main-mode', this, ( newAppMainMode ) => {
      if( that._isMounted ){
        let next = ( that.state.forceRenderCnt + 1 );
        that.setState({
          "forceRenderCnt": next
        });
      }
    });

    // Look when order4appointment call is loaded
    this.pollServiceRequestLoaded();
  }


  /** 
   * Wait in background for ServiceRequest draft to be loaded
   * If founf / loaded, show UI button to proceed with reperat visit booking
   */
  pollServiceRequestLoaded = () => {	
    var that = this;
    let waitMs = 400;
    
    if ( this.timerPollServiceRequestLoadedPoll != null) {
      clearTimeout( this.timerPollServiceRequestLoadedPoll );
    }
    
    if( this.serviceRequestLoadedTimeoutCount > 20 ){
      console.log( 'No order4appointment found, but still waiting for it in the background' );
      let next = ( that.state.forceRenderCnt + 1 );
      that.setState({
        "forceRenderCnt": next,
        "finishedTryingToLoad" : true 
      });
      
      waitMs = 1000;
    }

    let appointmentOrderFound  = this.findFirstOrderForAppointmentResourceAsJson();
    
    if( appointmentOrderFound === null ){
      this.serviceRequestLoadedTimeoutCount++;
      this.timerPollServiceRequestLoadedPoll = setTimeout(function () {
        that.pollServiceRequestLoaded();
      }, waitMs );
      return;
    }
    
    console.log( 'order4appointment found' );
    let next = ( that.state.forceRenderCnt + 1 );
    that.setState({
      "forceRenderCnt": next,
      "finishedTryingToLoad" : true 
    });
    
  }
  
  /*
  eventServerCommunicationInRaw( payload ){
    if( this._isMounted ){
      let next = ( this.state.forceRenderCnt + 1 );
      this.setState({
        "forceRenderCnt": next
      });
    }
  }
  */

  pollServiceRequestSyncDone = () => {
    var that = this;
    
    if ( this.timerPollServiceRequestSyncedPoll != null) {
      clearTimeout( this.timerPollServiceRequestSyncedPoll );
    }
    
    if( this.serviceRequestSyncingTimeoutCount > 50 ){
      console.log( 'serviceRequest SYNC FAILED to complete' );
      let next = ( this.state.forceRenderCnt + 1 );
      this.setState({
        "proccedClicked" : false,
        "permanentlyFailed" : true,
        "forceRenderCnt": next
      });
      return;
    }
    
    // Wait until ServiceRequest is synced
    let serviceRequestTest = window.appEntityStore.getEntityByEntityId( window.mainResult.serviceRequestId );
    let syncing = window.appEntityStore.isRecourceSyncing( serviceRequestTest );
    
    if( syncing ){
      this.serviceRequestSyncingTimeoutCount++;
      this.timerPollServiceRequestSyncedPoll = setTimeout(function () {
        console.log( 'serviceRequest not yet synced' );
        that.pollServiceRequestSyncDone();
      }, 300 );
      return;
    }
    
    let currentAppMode = appState.getState( 'app-main-mode' );
    let appFeatureFlagsHelper = new Helper();
    let checkOtherHcLoadedCount = appFeatureFlagsHelper.featureIsEnabled('canChoosePractitionerFromAllServiceAtBooking', currentAppMode.featureFlags );

    // find simplybooks event_id / service via Documental HealthcareServiceId
    let originalHcs = window.appEntityStore.getEntityByEntityId( window.mainResult.repeatVisitOriginalHealthcareServiceId );
    if( originalHcs === null ){
      this.serviceRequestSyncingTimeoutCount++;
      this.timerPollServiceRequestSyncedPoll = setTimeout(function () {
        console.log( 'original HC not found or not loaded: ' + window.mainResult.repeatVisitOriginalHealthcareServiceId );
        that.pollServiceRequestSyncDone();
      }, 300 );
      return;
    }
    
    let repeatVisitBookingServiceId = this.getHealthcareServiceSimplybookId( originalHcs.toObject() );
    if( repeatVisitBookingServiceId === null ){
      alert( 'Failed to find service' );
      this.setState({
        "proccedClicked" : false
      });
      return;
    }

    // find simplybooks unit_id / practioner via Documental Practicioner ID
    let originalPractioner = window.appEntityStore.getEntityByEntityId( window.mainResult.repeatVisitOriginalPracticionerResourceId );
    if( originalPractioner === null ){
      this.serviceRequestSyncingTimeoutCount++;
      this.timerPollServiceRequestSyncedPoll = setTimeout(function () {
        console.log( 'Original pr. not yet loaded' );
        that.pollServiceRequestSyncDone();
      }, 300 );
      return;
    }
    
    let repeatVisitBookingPracticionerId = this.getPracticionerSimplybookId( originalPractioner.toObject() );
    if( repeatVisitBookingPracticionerId === null ){
      alert( 'Failed to find practicioner' );
      this.setState({
        "proccedClicked" : false
      });
      return;
    }

    let proposedHcResourceFound = false;
    let otherHcLoadedCount = 0; // wait for other resources to be loaded as well, in some cases patient can select from multiple services
    let foundServiceId = '-1';// main service id from service request performer
    let foundServiceName = '';// Name of the service ( foundServiceId )
    let foundAllServiceResourceId = null;
    let foundAllServiceId = '';
    let foundAllServiceName = '';
    let repeatVisitServicesProposed = [];
    
    // wait HealthcareService-es to be loaded also
    // let hcsResources = window.appEntityStore.getAllResourcesBySearchParams( { "resourceType" : "HealthcareService" } );
    
      // ServiceRequest synced. Now look/wait for HealthcareService that is requested by ServiceRequest.performer(s)
      let serviceRequestTestJson = serviceRequestTest.toObject();
      //let hcsId = serviceRequestTestJson.performer[ 0 ].reference.split("HealthcareService/").join("");

      //Go trough performers and check is there a provider-choice "all" in HealthcareService resources
      //Other one is the main service (probably on first position)
      for( var ii in serviceRequestTestJson.performer ){
        let hcsId2 = serviceRequestTestJson.performer[ ii ].reference.split("HealthcareService/").join("");
        let hcs2 = window.appEntityStore.getResourceById( hcsId2 );
        if( hcs2 !== null ){
          let hcsJson2 = hcs2.toObject();

          if( this.healthcareServiceHasProviderChoiceAll( hcsJson2 ) ){
            foundAllServiceId = this.getHealthcareServiceSimplybookId( hcsJson2 );
            console.log('FOUND ALL SERVICE', foundAllServiceId );
            if( foundAllServiceId !== null ){
              foundAllServiceResourceId = hcs2.getId();
              foundAllServiceName = this.getHealthcareServiceNameTranslated( hcsJson2 );
            }
          } else {
            foundServiceId = this.getHealthcareServiceSimplybookId( hcsJson2 );
            console.log('FOUND Main SERVICE', foundServiceId);
            if( foundServiceId !== null ){
              foundServiceName = this.getHealthcareServiceNameTranslated( hcsJson2 );
              proposedHcResourceFound = true;
            }

            repeatVisitServicesProposed.push( {
              "simplybookServiceId" : foundServiceId,
              "name" : this.getHealthcareServiceNameTranslated( hcsJson2 )
            } );
          }
        }
      }

      if( checkOtherHcLoadedCount ){
        let otherHcs = window.appEntityStore.getAllResourcesBySearchParams( { "resourceType" : "HealthcareService" } );
        otherHcLoadedCount = otherHcs.length;
      }
    
    if( otherHcLoadedCount < 2 && checkOtherHcLoadedCount ){
      console.log( "FF: Waiting healthcare services to be loaded before continuing" );
      console.log( 'foundAllServiceResourceId: '  + foundAllServiceResourceId );
    }

    let othersCountCheckResult = false;
    if( !checkOtherHcLoadedCount ){
      othersCountCheckResult = true;
    } else {
      if( otherHcLoadedCount > 1 ){ // < 2
        othersCountCheckResult = true;
      }

      // keep services array to window.mainResult so vanilla / jQuery can use this in timewpicker component
      // let otherHcs = window.appEntityStore.getAllResourcesBySearchParams( { "resourceType" : "HealthcareService" } );
    }

    if(
      !proposedHcResourceFound || 
      !othersCountCheckResult
    ){
      this.serviceRequestSyncingTimeoutCount++;
      this.timerPollServiceRequestSyncedPoll = setTimeout(function () {
        that.pollServiceRequestSyncDone();
      }, 300 );
      return;
    }
    
    // Setup mode/strategy for time picker
    window.mainResult.activeMode           = 'repeatVisit';
    window.mainResult.showModeDefault      = true;
    window.mainResult.showModeAllDoctors   = ( foundAllServiceResourceId !== null && checkOtherHcLoadedCount ) ? true : false; // actually not needed since we wait for it, otherwise error occurs
    
    //after 2024-12-23  Dont show default mode and show all doctors mode anymore in repeat visit mode
    window.mainResult.showModeDefault      = false;
    window.mainResult.showModeAllDoctors   = false;

    // main service ID (simplyBook event_id) and name
    window.mainResult.bookingServiceId   = foundServiceId;
    window.mainResult.bookingServiceName = foundServiceName;
    
    // allDoctors service ID (simplyBook event_id) and name
    window.mainResult.allDoctorsBookingServiceId   = foundAllServiceId;
    window.mainResult.allDoctorsBookingServiceName = foundAllServiceName;

    // Repeat-vist / same doctor service ID (simplyBook event_id)
    // It's original from service request before putting it into plan
    // Add both service and practicioner simplyBook ID's
    window.mainResult.repeatVisitBookingServiceId      = repeatVisitBookingServiceId; // Simplybooks event_id
    window.mainResult.repeatVisitBookingPracticionerId = repeatVisitBookingPracticionerId; // Simplybooks unit_id
    window.mainResult.repeatVisitServicesProposed = repeatVisitServicesProposed;// simplebook.me service ID's to show as option on timepicker in repeat visit mode
    
    console.log( 'window.mainResult after sync:: ' );
    console.log( window.mainResult );
    
    this.props.onProceedClick( );
  }


  /**
   * Look for provider-choice "all" in HealthcareService resource json
   * 
   * "extension": [
   *
   *      {
   *        "url": "http://documental.ee/fhir/extension/healthcareservice/provider-choice",
   *      "valueCode": "all"
   *      }
   *    ],
   *
   * @param object hd 
   * @return booolean
   */

  healthcareServiceHasProviderChoiceAll( hd ){
    if( typeof hd.extension !== "undefined" ){
      for( var ii in hd.extension ){
        if( 
          typeof hd.extension[ ii ].url !== "undefined" && 
          hd.extension[ ii ].url === "http://documental.ee/fhir/extension/healthcareservice/provider-choice"
        ){
          if(
            typeof hd.extension[ ii ].valueCode !== "undefined" && 
            hd.extension[ ii ].valueCode === "all"
          ){
            return true;
          }
        }
      }
    }

    return false;
  }


  /**
   * Find simplybook.me event_id (service) from 
   * HealthcareService resource json
   *
   * @param object hcsJson 
   * @return booolean|null
   */
  getHealthcareServiceSimplybookId( hcsJson ){
    
    if( typeof hcsJson.identifier !== "undefined" ){
      for( var ii in hcsJson.identifier ){
        if( 
          hcsJson.identifier[ ii ].system === "http://documental.ee/fhir/naming/simplybook/service/id" && 
          typeof hcsJson.identifier[ ii ].value !== "undefined"
        ){
          return hcsJson.identifier[ ii ].value;
        }
      }
    }

    return null;
  }


  /**
   * Find simplybook unit_id (practicioner) from 
   * Practicioner resource json
   * 
   * @param object json 
   * @return booolean|null
   */
  getPracticionerSimplybookId( json ){
    
    if( typeof json.identifier !== "undefined" ){
      for( var ii in json.identifier ){
        if( 
          json.identifier[ ii ].system === "http://documental.ee/fhir/naming/simplybook/provider/id" && 
          typeof json.identifier[ ii ].value !== "undefined"
        ){
          return json.identifier[ ii ].value;
        }
      }
    }

    return null;
  }


  /**
   * 
        "name": "Repeat visit (en)",
        "communication": [
          {
            "coding": [
              {
                "system": "urn:ietf:bcp:47",
                "code": "en",
                "display": "English"
              }
            ]
          }
        ]
   *
   * @param object hc 
   * @return booolean
   */

  getHealthcareServiceNameTranslated( hd ){
    if( typeof hd.name !== "undefined" ){
      return hd.name;
    }

    return "";
  }


  
  /**
   * Open a url in new tab
   * 
   * @param string videoLink 
   * @returns 
   */
  handleVideoCallClick( videoLink ) {

    window.open( videoLink, '_blank' );

    return false;
  }


  /**
  
    {
      "fullUrl": "ServiceRequest/b078337b-312f-442e-b833-f74aa4d017ff",
      "resource": {
        "resourceType": "ServiceRequest",
        "id": "b078337b-312f-442e-b833-f74aa4d017ff",
        "meta": {
          "profile": [
            "http://documental.ee/fhir/profile/servicerequest/order4appointment"
          ]
        },
        "status": "draft",
        "intent": "option",
        "code": {
          "coding": [
            {
              "system": "http://documental.ee/fhir/codesystem/service-request-type",
              "code": "BOOKING"
            }
          ]
        },
        "subject": {
          "reference": "Patient/bb53a096-a7df-43ba-9adf-3cce81265ef0"
        },
        "encounter": {
          "reference": "Encounter/96e320c5-4bee-444d-a596-e9c391b3c714"
        },
        "authoredOn": "2024-05-01T07:31:06+00:00",
        "requester": {
          "reference": "Patient/bb53a096-a7df-43ba-9adf-3cce81265ef0"
        },
        "performer": [
          {
            "reference": "Practitioner/ebdb3c5d-d298-4810-95c4-5a2b6e5341c4"
          },
          {
            "reference": "HealthcareService/hcs5"
          }
        ]
      }
    }
   * 
   * There should be only one?
   * 
   * return null|object
   */
  findFirstOrderForAppointmentResourceAsJson( ) {
    let serviceRequests = window.appEntityStore.getAllResourcesBySearchParams({
      "resourceType" : "ServiceRequest",
    });
    
    for( var i2 in serviceRequests ){
      let resource = serviceRequests[ i2 ].toObject();
      let metaprofile = this.getFirstMetaProfileUrl( resource );
      if( metaprofile === 'http://documental.ee/fhir/profile/servicerequest/order4appointment' ){
        
        if( serviceRequests[ i2 ].getStatus() === 'draft' ){
          return resource;
        }
      }
    }

    return null;


  }


  /**
   * 
   * 
   * @returns void
   */
  handleBookAppointmentClick( ) {
    if( this.state.proccedClicked ){
      return false;
    }

    if( typeof window.repeatVisitTimepickerVisited !== 'undefined' && window.repeatVisitTimepickerVisited ){
      console.log( 'Timepicker already visited, skip everything here and go back there' );
      this.props.onProceedClick( );
      return;
    }
    
    this.setState({
      "proccedClicked" : true
    });

    // 1. Find template for repeat-visit ServiceRequest
    let resourceJson = this.findFirstOrderForAppointmentResourceAsJson();
    if( resourceJson === null ){
      alert('Failed to find repeat visit service. Please refresh. If this error persists, please contact support');
      this.setState({
        "proccedClicked" : false
      });
      return false; 
    }

    // 2. find original HealthcareService and practicioner ID from performer's array in template ServiceRequest
    let healthcareServiceResourceId = null;
    let practicionerResourceId = null;
    if( 
      typeof resourceJson.performer !== 'undefined' 
    ){
      for( var i in resourceJson.performer ){
        if( typeof resourceJson.performer[ i ].reference !== 'undefined' ){
          if( resourceJson.performer[ i ].reference.indexOf( 'HealthcareService/' ) !== -1 ){
            healthcareServiceResourceId = resourceJson.performer[ i ].reference.replace( 'HealthcareService/', '' );
            if( healthcareServiceResourceId.trim() === '' ){
              healthcareServiceResourceId = null;
            }
          }
          if( resourceJson.performer[ i ].reference.indexOf( 'Practitioner/' ) !== -1 ){
            practicionerResourceId = resourceJson.performer[ i ].reference.replace( 'Practitioner/', '' );
            if( practicionerResourceId.trim() === '' ){
              practicionerResourceId = null;
            }
          }
        }
      }
    }
    if( healthcareServiceResourceId === null || practicionerResourceId === null ){
      // alert('Failed to start. If this error persists, please contact support');
      console.log( healthcareServiceResourceId + ' ' + practicionerResourceId);
      console.log( resourceJson.performer );
      let next = ( this.state.forceRenderCnt + 1 );
      this.setState({
        "forceRenderCnt" : next,
        "proccedClicked" : false,
        "permanentlyFailed" : true
      });
      return false; 
    }
    
    // 3. keep this info for a while to be used in next steps
    // and start polling HelahtcareService resource found
    
    let mainResult = {
      "resolvedFromResource" : false,
      "code" : "",
      "system" : "",
      "display" : "",

      "finalSuggestion" : "", // consultation  ||  all-good
      "finalServiceProvider" : "", // psychiatrist or psychologist
      "finalSuggestionTitle" : "",
      "finalSuggestionText" : "",

      "serviceRequestId" : resourceJson.id, // ServiceRequest ID where eventually booking will be saved
      "bookingServiceId" : null, // simplebook.me service ID discovered (integer)

      "repeatVisitOriginalHealthcareServiceId" : healthcareServiceResourceId,
      "repeatVisitOriginalPracticionerResourceId" : practicionerResourceId,
      "repeatVisitServicesProposed" : [], // simplebook.me service ID's to show as option on timepicker in repeat visit mode

      "activeMode" : "default",
      "showModeDefault" : false,
      "showModeAllDoctors" : false,
      "showModeRepeatVisit" : true

    }

    window.mainResult = mainResult;

    console.log( "Main object before polling HealtCareServices" );
    console.log( mainResult );
    
    // 4. update serviceRequestId to plan mode to get 
    // HealthCare services list for next steps (star poll for them)
    let serviceRequest = window.appEntityStore.getResourceById( window.mainResult.serviceRequestId );
    serviceRequest.setStatus( "draft" );
    serviceRequest._resourceLiteral.intent = "plan";
    window.appEntityStore.saveResource( serviceRequest );
    
    this.pollServiceRequestSyncDone();

    return false;
  }
  
  componentWillUnmount() {
    this._isMounted = false;
    
    if ( this.timerPollServiceRequestLoadedPoll != null) {
      clearTimeout( this.timerPollServiceRequestLoadedPoll );
    }
    if ( this.timerPollServiceRequestSyncedPoll != null) {
      clearTimeout( this.timerPollServiceRequestSyncedPoll );
    }
  }

  
  /**
   * 
   * 
   * @returns array
   */
  findActiveVideoCalls( ) {

    let videoCalls = [];
    let serviceRequests = window.appEntityStore.getAllResourcesBySearchParams({
      "resourceType" : "ServiceRequest",
    });
    
    for( var i2 in serviceRequests ){
      let resource = serviceRequests[ i2 ].toObject();
      console.log( resource );
      
      /*
      let serviceRequestType = '';

      if( typeof resource.code != 'undefined' && typeof resource.code.coding != 'undefined' ){
        for( var j in resource.code.coding ){
          if( 
            typeof resource.code.coding[ j ].code != 'undefined' 
            // documental.ee/fhir/codesystem/service-request-type <- system
          ){
            serviceRequestType = resource.code.coding[ j ].code;  // BOOKING
          }
        }
      }      
      */

      // let metaprofile = this.getFirstMetaProfileUrl( resource );

      let roomUrl = ''; 
      if( typeof resource.extension != 'undefined' ){
        for( var i in resource.extension ){
          if( typeof resource.extension[ i ].url != 'undefined' && resource.extension[ i ].url === 'http://documental.ee/fhir/extension/telemental/room' ){
            if( typeof resource.extension[ i ].valueUrl != 'undefined' ){
              roomUrl = resource.extension[ i ].valueUrl;
            }
          }
        }
      }

      let timeOfCall = '';
      if( typeof resource.occurrenceDateTime != 'undefined' ){ 
        timeOfCall = resource.occurrenceDateTime;
      } else if( typeof resource.occurrencePeriod != 'undefined' ){ 
        timeOfCall = resource.occurrencePeriod.start;
      }

      //timeOfCall = timeOfCall.substr( 0, 16 );
      //timeOfCall = timeOfCall.replace( "T", " " );

      if( 
        timeOfCall !== '' && 
        roomUrl !== '' && 
        serviceRequests[ i2 ].getStatus() === 'active'  
        // metaprofile === 'http://documental.ee/fhir/profile/servicerequest/booking'
      ){
        videoCalls.push({
          "roomUrl" : roomUrl,
          "timeOfCall" : timeOfCall
        });
      }
    }

    return videoCalls;
  }


  /**
   * 
   * 
   * @returns null|string
   */
  findClosestVideoCall( ) {
    let videoCalls = this.findActiveVideoCalls();
    // TODO: need to order by actual timeOfCall- take the closest one- becasue maybe there is more than one active video call
    if( videoCalls.length > 0 ){
      // filter by timeOfCall property which is date in format like "2024-05-08T13:00:00+00:00"
      videoCalls.sort( function( a, b ){
        return new Date( a.timeOfCall ) - new Date( b.timeOfCall );
      });
      
      return videoCalls[ 0 ].roomUrl;
    }

    return null;
  }

  /**
   * find profile url like: 
   *   - http://documental.ee/fhir/profile/servicerequest/booking
   *   - http://documental.ee/fhir/profile/servicerequest/order4appointment
   * 
   * @param object resourceJson 
   * @returns null|string
   */
  getFirstMetaProfileUrl( resourceJson ) {
    if( 
      typeof resourceJson.meta != 'undefined' && 
      typeof resourceJson.meta.profile != 'undefined' 
    ){
      for( var i in resourceJson.meta.profile ){
        return resourceJson.meta.profile[ i ];
      }
    }
    return null;
  }
  
  
  render() {
    var that = this;

    let videoConsultationFound = this.findClosestVideoCall();
    let appointmentOrderFound  = this.findFirstOrderForAppointmentResourceAsJson();

    if( this.props.sessionStillLoading ){
      return (
        <div className="app-fragment app-fragment-app-loading">  
          <div>
            <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
          </div>
        </div>
      );
    }

    //let generalError = i18n.t('An technical error occurred, please try again.'); // "There was an error with your request. Please try again."
    let generalError = i18n.t("At the moment, there are no planned visits and it's not yet possible to book a new visit either.");
    let newErrorKey = "error-" + this.state.forceRender;

    return (
      <div>
        
        <TopNav showLanguageLinks={false} />

        
        {( this.state.permanentlyFailed ) && (
          <ErrorBar key={newErrorKey} message={generalError} closable={false} />
        )}
        
        <div className="app-fragment pull-bottom-fixed">  
          

          <div className="text-links">
            
            
            {(  !this.state.finishedTryingToLoad ) && (
              <div className="text-white" style={{
                "textAlign": "center",
                "marginTop": "2rem",
                "marginBottom": "3rem"
              }}>
                <div className="" style={{"lineHeight": "1rem"}}>  
                  <div style={{"lineHeight": "1.5rem"}}>
                    <div className="lds-ring small">
                      <div></div>
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                </div>
              </div>
            )}


            {( videoConsultationFound !== null && videoConsultationFound !== '' ) && (
              <div className="text-link" onClick={ function(){ that.handleVideoCallClick( videoConsultationFound ) } } >
                <div className="text"><Trans>Enter video consultation</Trans></div>
                <div className="arrow-right"></div>
              </div>
            )}

            {( appointmentOrderFound !== null  ) && (
              <div className="text-link" onClick={ function(){ that.handleBookAppointmentClick( ) } } >
                <div className="text"><Trans>Book a repeat visit</Trans></div>
                
                { this.state.proccedClicked && (
                  <div className="" style={{"lineHeight": "1rem"}}>  
                    <div style={{"lineHeight": "1rem"}}>
                      <div className="lds-ring small">
                        <div></div>
                        <div></div>
                        <div></div>
                        <div></div>
                      </div>
                    </div>
                  </div>
                )}
                { !this.state.proccedClicked && (
                  <div className="arrow-right"></div>
                )}
                
              </div>
            )}
            
            {( videoConsultationFound === null && appointmentOrderFound === null && this.state.finishedTryingToLoad ) && (
              <div className="text-white" style={{
                "textAlign": "center",
                "font-size": "1.25rem",
                "lineHeight": "1.5",
                "marginBottom": "4rem"
              }}>
                <div className="text"><Trans>At the moment, there are no planned visits and it's not yet possible to book a new visit either.</Trans></div>
              </div>
            )}
              
          </div>
          
          <div className="text-base text-white" style={{"textAlign": "left", "color" : "#bbbbbb"}}>
            © Documental OÜ {/* 2017 - 2023 */}
          </div>

        </div>
      </div>
    );
  }

}

export default RepeatVisitLandingPage;